import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";

const mapSceneLevel = (scene, zoneType) => {
  switch (zoneType) {
    case zoneTypeKeys.IO:
      return scene.defaultValue.isOn === true ? "On" : "Off";
    case zoneTypeKeys.CBUS:
      return MapCbusSceneLevel(scene);
    default:
      return scene.defaultValue;
  }
};

const MapCbusSceneLevel = scene => {
  if (!scene.scene.luxBandsAreEnabled || !scene.luxBands) {
    return scene.defaultValue.levelPercentage == null
      ? ""
      : scene.defaultValue.levelPercentage.toString();
  }

  const values = scene.luxBands.map(x => x.levelPercentage);

  values.push(scene.defaultValue.levelPercentage);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);

  if (minValue === maxValue) {
    return minValue.toString();
  }

  return `${minValue}-${maxValue}`;
};

export default mapSceneLevel;
